// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf066dbd","455":"a3fbd865","977":"a0a8c8c9"}[chunkId] + ".chunk.js";
};